import { render, staticRenderFns } from "./CSRAccountList.vue?vue&type=template&id=497bfc09&scoped=true&"
import script from "./CSRAccountList.vue?vue&type=script&lang=js&"
export * from "./CSRAccountList.vue?vue&type=script&lang=js&"
import style0 from "./CSRAccountList.vue?vue&type=style&index=0&id=497bfc09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497bfc09",
  null
  
)

export default component.exports